module.exports = __webpack_public_path__ + "static/media/income-tax.a94a3d95.jpg";